/* This is just a static page to display when no conversation is selected. */
import React from 'react';
import QRCode from 'qrcode.react';
import { CLIENT_ID, DESK_AUTH, LOGIN_WITH_SSO, REDIRECT_URI, URL_REDIRECT_SSO, GUIDELINES_LINK } from '../config';
import { AuthServices, AuthSsoServices } from '../services/auth';
import { user } from '../stores/storages/UserStorage';
import { profile } from '../stores/storages/ProfileStorage';
import { clientInfo } from '../version';
import { IconLogo } from '../icons/png';
import { IconOpenLink } from '../icons/svg';
import banner from '../img/login/banner.png'
import Helpers from '../lib/helpers';
import { FormattedMessage, injectIntl } from 'react-intl';
import HashNavigation from '../lib/navigation';
import StringUtils from '../lib/string';
import { Tinode } from "../tinode/tinode";
import { language } from '../stores/storages/LanguageStorage';

class LoginQrCode extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = this.initState();

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleDestroyQr = this.handleDestroyQr.bind(this);
    this.interval = this.interval.bind(this);
    this.processCountDown = this.processCountDown.bind(this);
    this.processLoginSso = this.processLoginSso.bind(this);
    this.handleAuthenticateSso = this.handleAuthenticateSso.bind(this);
    this.dataProcessing = this.dataProcessing.bind(this);
    this.handleSetLanguage = this.handleSetLanguage.bind(this);
  }

  componentWillMount() {
    this.interval(false);
    this.processLoginSso();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  async handleAuthenticate() {
    const { keyQrCode } = this.state;
    await AuthServices(keyQrCode)
      .then((res) => {
        if (res && res.username) {
          this.dataProcessing(res, keyQrCode)
        } else if (res && Number(res.code) === 423) {
          this.handleDestroyQr();
        }
      })
      .catch((error) => console.log(error))
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.nodeLang && !this.nodeLang.contains(event.target)) {
      this.showLanguageOptions(false)
    }
  }

  async handleAuthenticateSso(code) {
    const { keyQrCode } = this.state;
    await AuthSsoServices(code, keyQrCode)
      .then((res) => {
        if (res && res.username) {
          this.dataProcessing(res, keyQrCode);
        }
      })
      .catch((error) => console.log(error))

  }

  handleDestroyQr() {
    this.setState((prevState) => {
      const { intervalAuth } = prevState;
      clearInterval(intervalAuth);
      return {
        ...prevState,
        countDown: 0,
        intervalAuth: null,
      };
    })
  }

  processCountDown() {
    setTimeout(() => {
      this.setState(prevState => ({
        countDown: prevState.countDown - 1
      }), () => {
        if (this.state.countDown <= 0) {
          this.handleDestroyQr();
        } else {
          this.processCountDown();
        }
      });
    }, 1000);
  }

  initState() {
    const keyQrCode = StringUtils.randomString(40)
    const keyE2E = this.genKeyE2E()

    return {
      isShowLanguageOptions: false,
      countDown: 0,
      intervalAuth: null,
      keyQrCode,
      keyE2E,
      urlRedirect: URL_REDIRECT_SSO + `?step=identifier&clientId=${CLIENT_ID}&redirectUri=${encodeURIComponent(REDIRECT_URI)}&isFromWeb=true&isShowPass=false`
    }
  }

  interval(isResetKeyE2E) {
    const keyQrCode = StringUtils.randomString(40)
    const keyE2E = this.genKeyE2E(isResetKeyE2E)

    this.setState({
      countDown: 60,
      keyQrCode,
      keyE2E,
      intervalAuth: setInterval(this.handleAuthenticate, 3000),
    }, this.processCountDown);
  }

  genKeyE2E() {
    let keyE2E = localStorage.getItem('prekey_decrypt_key')
    if (keyE2E === null) {
      keyE2E = StringUtils.randomString(6)
      localStorage.setItem('prekey_decrypt_key', keyE2E)
    }
    return keyE2E
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalAuth);
  }

  processLoginSso() {
    const urlParams = HashNavigation.parseUrlSearch(window.location.search);
    const code = urlParams.get('code');
    if (!!code && LOGIN_WITH_SSO) {
      this.handleAuthenticateSso(code);
    }
  }

  dataProcessing(res, ssid) {
    const { formatMessage } = this.props.intl
    const { username } = res;
    user.username = username;
    user.save()
    profile.authAPI = res;
    profile.clientInfo = clientInfo;
    profile.sessionId = ssid;
    profile.isSendDeliveredSeen = true;
    profile.isHighPhotoQuality = true;
    profile.save();
    this.props.callback();
    Helpers.showSuccessToasts(formatMessage({
      id: 'login_success',
      defaultMessage: "Login successful",
    }));
  }

  handleSetLanguage(lang) {
    language.language = lang;
    language.save();
    this.showLanguageOptions(false);
    window.location.reload();
  }

  showLanguageOptions = (isShow) => {
    this.setState({
      isShowLanguageOptions: isShow,
    })
  }

  renderLanguage() {
    const { isShowLanguageOptions } = this.state

    let currentItem = Tinode.LANGUAGE_SUPPORT[0]
    const currentItemList = Tinode.LANGUAGE_SUPPORT.filter(item => item.lang == language.language)
    if (currentItemList.length > 0) {
      currentItem = currentItemList[0]
    }

    return (
      <div
        className='language'
        ref={nodeLang => this.nodeLang = nodeLang}
      >
        <div>
          <div
            className="current-language"
            onClick={() => this.showLanguageOptions(!isShowLanguageOptions)}
          >
            <img src={currentItem.image} alt={currentItem.name} />
            <span>{currentItem.name}</span>
          </div>
        </div>
        {isShowLanguageOptions && <div className="dropdown-content">
          {Tinode.LANGUAGE_SUPPORT.map((item) => (
            <div
              key={item.id}
              className={`dropdown-option ${language.language === item.lang ? 'selected' : ''}`}
              onClick={() => this.handleSetLanguage(item.lang)}
            >
              <img src={item.image} alt={item.name} />
              <span>{item.name}</span>
            </div>
          ))}
        </div>
        }
      </div>
    )
  }

  render() {
    const { keyQrCode, countDown, urlRedirect, keyE2E } = this.state;
    const { formatMessage } = this.props.intl
    const qrCode = `${DESK_AUTH}${keyQrCode}?key=${keyE2E}`
    let guideLink = ''
    switch (language.language) {
      case 'vi':
        guideLink = GUIDELINES_LINK.VI
        break;
      case 'en':
        guideLink = GUIDELINES_LINK.EN
        break;
      case 'lo':
        guideLink = GUIDELINES_LINK.LO
        break;
      default:
        guideLink = GUIDELINES_LINK.VI
        break;
    }

    return (
      <div id="login-view">
        <div className="logo"><IconLogo /></div>
        {this.renderLanguage()}
        <div className={`container${this.props.loading ? '': ' loaded'}`}>
          <div className="banner">
            <img src={banner} alt="" />
          </div>
          <div className="content-wrapper">
            <div className="content">
              <div className={`login_qr ${!LOGIN_WITH_SSO && 'only_login_qr'}`}>
                <div className="title">
                  <FormattedMessage
                    id='login_with_qrcode'
                    defaultMessage='Login with QR Code'
                  />
                </div>
                <div className="form">

                  <div className="qr_code">
                    <div className="qr">
                      <QRCode
                        id='login_qr_code'
                        className="border"
                        value={qrCode}
                        size={176}
                        style={{ opacity: countDown <= 0 ? '0.1' : 1 }}
                      />
                      {countDown <= 0 &&
                        <div className="expired">
                          <button className="btn" onClick={() => this.interval(true)}>
                            <FormattedMessage
                              id='login_get_code'
                              defaultMessage=' Get new code'
                            />
                          </button>
                        </div>
                      }
                    </div>
                    <div className="desc">
                      <FormattedMessage
                        id='login_qr_expired'
                        defaultMessage='QR codes expire after'
                      /> <span>{countDown}s</span>
                    </div>
                  </div>
                  <div className="guide">
                    <div className="box-step">
                      <div className="step">
                        <div className="num-step">1</div>
                        <div className="text-step"
                          dangerouslySetInnerHTML={{
                            __html: formatMessage({
                              id: 'login_step_1',
                              defaultMessage: 'Open the <span>Mocha</span> application on your phone'
                            })
                          }}>
                        </div>
                      </div>
                      <div className="step">
                        <div className="num-step">2</div>
                        <div className="text-step"
                          dangerouslySetInnerHTML={{
                            __html: formatMessage({
                              id: 'login_step_2',
                              defaultMessage: 'On the Home page, find the <span>QR code</span> function in the <span>Services</span> section.'
                            })
                          }}>
                        </div>
                      </div>
                      <div className="step">
                        <div className="num-step">3</div>

                        <div className="text-step"
                          dangerouslySetInnerHTML={{
                            __html: formatMessage({
                              id: 'login_step_3',
                              defaultMessage: 'Please <span>scan the QR code</span> on the left to log in'
                            })
                          }}>
                        </div>
                      </div>
                    </div>
                    <a className="guide-link" href={guideLink} target='_blank'>
                      <FormattedMessage
                        id='detailed_instructions'
                        defaultMessage='Detailed instructions'
                      />  <IconOpenLink />
                    </a>
                  </div>
                </div>
              </div>
              {LOGIN_WITH_SSO &&
                <React.Fragment>
                  <div className="or">
                    <FormattedMessage
                      id='login_or'
                      defaultMessage='Or'
                    />
                  </div>
                  <div className="button">
                    <a href={urlRedirect}>
                      <button>
                        <FormattedMessage
                          id='login_btn_sso'
                          defaultMessage='Login with SSO account'
                        />
                      </button>
                    </a>
                  </div>
                </React.Fragment>
              }
            </div>
          </div>
        </div>
      </div >
    );
  }
};

export default injectIntl(LoginQrCode);